var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('header-component',{ref:"header"}),_c('div',{staticClass:"app-inner"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }